import { ssoProvider, type SsoProvider } from "@Helpers/ssoProvider";

// URL contract for the central-auth account-linking handoff. The provider
// popups (Google/Microsoft/Apple) only accept origins registered in each
// provider's console — that's the central-auth domain, not portal subdomains —
// so portal pages redirect to LinkingAccount on the central domain and bounce
// back to `redirectUrl` with the outcome params appended.
export const LINKING_ACCOUNT_PATH = "/linkingAccount";
export const LINK_PROVIDER_PARAM = "linkAccount";
export const LINK_REDIRECT_URL_PARAM = "redirectUrl";
export const LINK_RESULT_PARAM = "linkResult";
export const LINK_RESULT_PROVIDER_PARAM = "linkProvider";
export const LINK_RESULT_ERROR_CODE_PARAM = "linkErrorCode";
export const LINK_RESULT_SUCCESS = "success";
export const LINK_RESULT_ERROR = "error";

const protocol = () => (process.env.REACT_APP_ENV == "development" ? "http" : "https");

export function buildLinkingAccountUrl(centralAuthHost: string, provider: SsoProvider): string {
  const params = new URLSearchParams({
    [LINK_PROVIDER_PARAM]: provider,
    [LINK_REDIRECT_URL_PARAM]: window.location.href,
  });
  return `${protocol()}://${centralAuthHost}${LINKING_ACCOUNT_PATH}?${params}`;
}

export function parseSsoProvider(raw: string | null): SsoProvider | null {
  if (!raw) return null;
  // Matching against the canonical values narrows to SsoProvider without asserting.
  return Object.values(ssoProvider).find((provider) => provider === raw) ?? null;
}

// Only accept redirect targets on the central-auth domain or its portal
// subdomains — anything else would make LinkingAccount an open redirect.
export function parseAllowedRedirectUrl(raw: string | null, centralAuthHost: string | undefined): URL | null {
  if (!raw || !centralAuthHost) return null;
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return null;
  }
  if (url.protocol !== "http:" && url.protocol !== "https:") return null;
  if (url.host === centralAuthHost || url.host.endsWith(`.${centralAuthHost}`)) return url;
  return null;
}
